import * as LucideIcons from "lucide-react";
import { motion } from "framer-motion";
import { usePillarsQuery } from "@/lib/queries";
import { useSettings } from "@/context/SettingsContext";

function PillarIcon({ name }) {
  const Icon = LucideIcons[name] || LucideIcons.Sparkles;
  return <Icon className="w-5 h-5" />;
}

export default function WhyChoose() {
  const { settings } = useSettings();
  const { data: pillars = [] } = usePillarsQuery();

  return (
    <section className="relative py-24 md:py-32 bg-[#0F0F0F]" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <div className="text-[0.7rem] tracking-[0.32em] uppercase text-[#D4AF37] font-semibold mb-4" data-testid="why-eyebrow">
            {settings?.why_eyebrow}
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white" data-testid="why-headline">
            {settings?.why_headline}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {pillars.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="group p-7 bg-[#0A0A0A] border border-[#2A2A2A] hover:border-[#D4AF37]/60 transition-all"
              data-testid={`pillar-${p.id}`}
            >
              <div className="w-12 h-12 border border-[#D4AF37]/40 flex items-center justify-center mb-5 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-black transition-colors">
                <PillarIcon name={p.icon} />
              </div>
              <h3 className="font-serif text-xl text-white mb-2">{p.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{p.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
